import { render, staticRenderFns } from "./MyOrderDanger.vue?vue&type=template&id=1825daee&scoped=true"
import script from "./MyOrderDanger.vue?vue&type=script&lang=js"
export * from "./MyOrderDanger.vue?vue&type=script&lang=js"
import style0 from "./MyOrderDanger.vue?vue&type=style&index=0&id=1825daee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825daee",
  null
  
)

export default component.exports